import { HttpClient } from "../HttpClient";
/**
 * * Get Applications List
 */
export const GetApplicationsList = async (params = {}) => {
  try {
    const { data } = await HttpClient.get(`api/application`, { params });
    return data;
  } catch (err) {
    return null;
  }
};
